export type IScreenTyp = "mobile" | "medeium" | "large";

const screenWidth = window.screen.width;
export const screenSize: IScreenTyp = screenWidth > 1366 ? "large" : screenWidth > 750 ? "medeium" : "mobile";